import { render, staticRenderFns } from "./Tetgeleg.vue?vue&type=template&id=5a82b6a3&"
import script from "./Tetgeleg.vue?vue&type=script&lang=js&"
export * from "./Tetgeleg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports